import { deserializeAs } from "cerialize";
import { Node } from "./node";
import { Breadcrumb } from "../breadcrumb";

export class Tree {

    @deserializeAs(Node)
    root: Node = null;

    getNode(path: string): Node {
        return path ? this.root.getNode(path) : this.root;
    }

    getBreadcrumbs(path: string, root?: Breadcrumb): Breadcrumb[] {
        return this.root.getBreadcrumbs(path, root);
    }

}
